<template lang="html">
  <div class="limiter">
    <div class="container-login100">
      <div class="wrap-login100">
        <h3>Email has successfully sent!</h3>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="css" scoped></style>
